// @flow
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {last} from 'lodash';
import MetricName from 'metrics/components/metricName/MetricName';
import TimeSeriesChart from 'charts/timeSeries/components/TimeSeriesChart';
import * as commonSelectors from 'profile/store/selectors';
import * as metricsSelectors from 'metrics/store/selectors';
import * as alertConsole from 'alerts.console/store/selectors';
import {getFormattedDateTime} from 'common/utils/dateService';
import {CHART_HEIGHT} from 'alerts.console/services/alertsConsoleService';
import {fetchAlertMetricDataPoints as fetchAlertMetricDataPointsAction} from 'alerts.console/store/actions';
import '../alertContent.module.scss';

let counter = 0;

const TOOLTIP_OPTIONS = {
  showMetricName: false,
  showAnomalyData: false,
  hideMeetIcons: true,
};

type PropTypes = {
  metric: Object,
  alertId: string,
  uiGroupName: string,
  startDate: number,
  endDate: number,
  timeScale: string,
  // connect
  timeZoneName: String,
  bucketStartTimeEnabled: Boolean,
  startBucketMode: Boolean,
  queryParamsViews: Object,
  fetchAlertMetricDataPoints: Function,
  isSingleLine?: boolean,
  specialHeader: boolean,
};

@connect(
  (state) => ({
    timeZoneName: commonSelectors.getTimeZoneName(state),
    bucketStartTimeEnabled: commonSelectors.getBucketStartTimeEnabled(state),
    resolutions: metricsSelectors.getMetricResolutions(state),
    startBucketMode: commonSelectors.getBucketStartTimeEnabled(state),
    queryParamsViews: alertConsole.getQueryParamsViews(state),
  }),
  {
    fetchAlertMetricDataPoints: fetchAlertMetricDataPointsAction,
  },
)
export default class NoDataAlertMetric extends PureComponent {
  props: PropTypes;

  static defaultProps = {
    isSingleLine: true,
  };

  constructor(props) {
    super(props);
    const {metric, alertId, uiGroupName} = this.props;

    this.id = `console.noData.chart_${(counter += 1)}`;
    this.chartEventsMeta = {
      key: `${alertId}_${metric.id}`, // unique ID for chart
      chartId: this.id,
      stateGroup: uiGroupName,
    };
  }

  componentDidMount() {
    // use didMount: ensures chart was created
    const {fetchAlertMetricDataPoints, metric, alertId, startDate, endDate, startBucketMode} = this.props;
    fetchAlertMetricDataPoints(
      {
        metricId: metric.id,
        endDate,
        startDate,
        startBucketMode,
        includeBaseline: false,
        timeScale: 'medium',
      },
      {
        ...this.chartEventsMeta,
        metricId: metric.id,
        intervals: metric.intervals,
        alertId,
      },
    );
  }

  render() {
    const {
      metric,
      timeZoneName,
      queryParamsViews,
      timeScale,
      bucketStartTimeEnabled,
      isSingleLine,
      specialHeader,
    } = this.props;
    const interval = last(metric.intervals);

    return (
      <div styleName="tile">
        <div styleName={['header', specialHeader ? 'extra-line' : ''].join(' ')}>
          <div styleName="header-row">
            <MetricName
              specialHeader={specialHeader}
              isSingleLine={isSingleLine}
              metric={metric}
              highlightText={queryParamsViews.searchQuery}
            />
          </div>

          <div styleName="header-row">
            <div styleName="row-left">
              This metric was last seen at {getFormattedDateTime(interval.lastSeenTime, timeZoneName)}
            </div>
          </div>
        </div>

        <div styleName={['chart', specialHeader ? 'special-height' : ''].join(' ')}>
          <TimeSeriesChart
            id={this.id}
            tooltip={TOOLTIP_OPTIONS}
            height={CHART_HEIGHT}
            bucketStartTimeEnabled={bucketStartTimeEnabled}
            timeScale={timeScale}
            timeZoneName={timeZoneName}
            enableClientZoom
            eventsMeta={this.chartEventsMeta}
          />
        </div>
      </div>
    );
  }
}
